import type { PlatformConnectionStatus } from '@/common/utils/parsePlatformConnectionStatus'
import { defineStore } from 'pinia'
import { computed, ref } from 'vue'

export const usePlatformConnectionStore = defineStore('platformConnection', () => {
  const status = ref<PlatformConnectionStatus>('CONNECTED')

  const isDisconnected = computed(() => status.value === 'DISCONNECTED')

  function markDisconnected(): void {
    status.value = 'DISCONNECTED'
  }

  function markReconnected(): void {
    status.value = 'CONNECTED'
  }

  function applyStatus(next: PlatformConnectionStatus): void {
    status.value = next
  }

  function reset(): void {
    status.value = 'CONNECTED'
  }

  return {
    status,
    isDisconnected,
    markDisconnected,
    markReconnected,
    applyStatus,
    reset,
  }
})
